import React from "react";
import ReactDOM from "react-dom";
import DealersMap from './views/DealersMap';

const rootElement = document.getElementById("dealers-map-root");
if (rootElement) {
    ReactDOM.render(<DealersMap />, rootElement);
}